import { industryTags } from '../../pageContents/industry/industryTags'
import { productsList } from '../../pageContents/products/productsList'
import { solutionTags } from '../../pageContents/solution/solutionTags'
import { menus } from '../../pages/about/configs'

export const Footer = () => {
  return (
    <div className='footer-container'>
      <div className='footer-wrap'>
        <div className='top'>
          <div className='left'>
            <div className='logos'>
              <div className='logo-box'>
                <a className='logo-home' href='/' title='' />
              </div>
              <div>
                <ul className='flex'>
                  <li>
                    {/* <a className='weixin-code-img' href='/' title='' /> */}
                    <div className='weixin-code-img' />
                    <p>微信公众号</p>
                  </li>
                  <li>
                    {/* <a className='shipin-code-img' href='/' title='' /> */}
                    <div className='shipin-code-img' />
                    <p>视频号</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className='right'>
            <div className='links'>
              <h5>产品服务</h5>
              <ul>
                {productsList.map(item => {
                  return (
                    <li key={`/products/${item.id}`}>
                      <a href={`/products/${item.id}`}>{item.name}</a>
                    </li>
                  )
                })}
              </ul>
            </div>
            <div className='links'>
              <h5>解决方案</h5>
              <ul>
                {solutionTags.map(item => {
                  return (
                    <li key={`/solution/${item.id}`}>
                      <a href={`/solution/${item.id}`}>{item.name}</a>
                    </li>
                  )
                })}
              </ul>
            </div>
            <div className='links'>
              <h5>应用案例</h5>
              <ul>
                {industryTags.map(item => {
                  const { id, name } = item
                  const url = `/industry/${id}`
                  return (
                    <li key={url}>
                      <a href={url}>{name}</a>
                    </li>
                  )
                })}
              </ul>
            </div>
            <div className='links'>
              <h5>关于我们</h5>
              <ul>
                {menus.map(item => {
                  const { name, props } = item
                  const { href, target, rel } = props
                  const url = rel === 'noreferrer' ? href : `/about/${href}`
                  return (
                    <li key={href}>
                      <a href={url} target={target}>
                        {name}
                      </a>
                    </li>
                  )
                })}
              </ul>
            </div>
            <div className='links'>
              <h5>技术支持</h5>
              <ul>
                <li>
                  <a href='https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzAxNzI3MTIzNw==&action=getalbum&album_id=2099255763616448515&scene=173&from_msgid=2653920421&from_itemidx=2&count=3&nolastread=1#wechat_redirect'>
                    世冠干货
                  </a>
                </li>
                <li>
                  <a href='https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzAxNzI3MTIzNw==&action=getalbum&album_id=2787794335781257217#wechat_redirect'>
                    常见问题
                  </a>
                </li>
                <li>
                  <a href='https://space.bilibili.com/2070644742?spm_id_from=333.337.0.0'>
                    培训教程
                  </a>
                </li>
              </ul>
            </div>
            <div className='links'>
              <h5>联系我们</h5>
              <ul>
                <li>电话：400-996-0325</li>
                <li>邮箱：marketing@globalcrown.com.cn</li>
                <li>地址：北京市海淀区东北旺西路8号院尚东数字谷A3 二层</li>
              </ul>
            </div>
          </div>
        </div>
        <div className='bottom'>
          <p>所有版权 © 2002&nbsp;-&nbsp;2025 世冠科技 - 保留所有权利</p>
          <p>
            <a href='https://beian.miit.gov.cn/#/Integrated/index'>京ICP备2021030104号-1</a>
          </p>
        </div>
      </div>
    </div>
  )
}
